import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
    getReviews,
    getReviewStats,
    approveReview,
    hideReview,
    restoreReview,
    deleteReview,
} from "../services/adminApi";

import ReviewHeader from "../components/reviews/ReviewHeader";
import ReviewStats from "../components/reviews/ReviewStats";
import ReviewFilters from "../components/reviews/ReviewFilters";
import ReviewTable from "../components/reviews/ReviewTable";

import "../styles/Reviews.css";

const Reviews = () => {
    const navigate = useNavigate();

    const [reviews, setReviews] = useState([]);
    const [filteredReviews, setFilteredReviews] = useState([]);
    const [stats, setStats] = useState({});
    const [loading, setLoading] = useState(true);

    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("all");
    const [rating, setRating] = useState("all");

    const loadData = async () => {
        try {
            setLoading(true);

            const [reviewRes, statsRes] = await Promise.all([
                getReviews(),
                getReviewStats(),
            ]);

            const reviewList = reviewRes.data.reviews || [];

            setReviews(reviewList);
            setFilteredReviews(reviewList);
            setStats(statsRes.data.stats || {});
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        let data = [...reviews];

        if (search) {
            data = data.filter((r) =>
                r.comment?.toLowerCase().includes(search.toLowerCase())
            );
        }

        if (status !== "all") {
            data = data.filter((r) => r.status === status);
        }

        if (rating !== "all") {
            data = data.filter(
                (r) => Number(r.rating) === Number(rating)
            );
        }

        setFilteredReviews(data);
    }, [reviews, search, status, rating]);

    const handleApprove = async (id) => {
        await approveReview(id);
        loadData();
    };

    const handleHide = async (id) => {
        await hideReview(id);
        loadData();
    };

    const handleRestore = async (id) => {
        await restoreReview(id);
        loadData();
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Delete this review?")) return;

        await deleteReview(id);
        loadData();
    };

    return (
        <div className="reviews-page">

            <ReviewHeader />

            <ReviewStats stats={stats} />

            <ReviewFilters
                search={search}
                setSearch={setSearch}
                status={status}
                setStatus={setStatus}
                rating={rating}
                setRating={setRating}
            />

            <ReviewTable
                loading={loading}
                reviews={filteredReviews}
                onView={(id) =>
                    navigate(`/admin/reviews/${id}`)
                }
                onApprove={handleApprove}
                onHide={handleHide}
                onRestore={handleRestore}
                onDelete={handleDelete}
            />

        </div>
    );
};

export default Reviews;